import { Route } from 'react-router-dom';
import PageUsers from '../../pages/raptor/settings/users/users.page';
import PermissionRoute from '../../guard/permission-route';

/** Solo admin/superadmin (mismo @Roles('admin') del backend). */
export const RaptorUsersRoutes = (
  <Route element={<PermissionRoute module="users" />}>
    <Route path="/users">
      <Route index element={<PageUsers />} />
    </Route>
  </Route>
);
